<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Log přihlášení - E-shop</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm4>
                <osobasearch v-model="osoba_id" all></osobasearch>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.datum | formatDate }}</td>
                  <td>{{ props.item.osoba.nazev_osoby }}</td>
                  <td>{{ props.item.ip }}</td>
                  <td>
                    <span v-if="props.item.zarizeni=='pc'">PC</span>
                    <span v-else-if="props.item.zarizeni=='mobil'">Mobil</span>
                    <span v-else-if="props.item.zarizeni=='tablet'">Tablet</span>
                  </td>
                  <td>{{ props.item.prohlizec }}</td>
                  <td>{{ props.item.rozliseni_sirka }}x{{ props.item.rozliseni_vyska }}</td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      updateItem: {},
      headers: [
        { text: 'ID', value: 'id', width: '30px' },
        { text: 'Datum', value: 'datum' },
        { text: 'Osoba', value: 'osoba.nazev_osoby', sortable: false},
        { text: 'IP adresa', value: 'ip', sortable: false},
        { text: 'Zařízení', value: 'zarizeni', sortable: false},
        { text: 'Prohlížeč', value: 'prohlizec', sortable: false},
        { text: 'Rozlišení', value: 'rozliseni_sirka', sortable: false},
      ],
      loadingTable: true,
      search: "",
      material: null,
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      items: [],
      dialog: false,
      activeItem: null,
      osoba_id: null
    }
  },
  computed: {
    th () {
      return window.th;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    osoba_id () {
      this.load();
    },
    pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("log/eshop-prihlaseni/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        osoba: this.osoba_id
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    showClick (v) {
      this.activeItem = v;
      this.dialog = true;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TestTools/LogEshopPrihlaseni.vue